var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.rates'] = (function () {
    'use strict';

    const initialize = (block) => {
        if (!block || !block.id) return;

        const carouselEl = block.querySelector('.block-rates__cards');
        if (carouselEl) {
            carousel(carouselEl);
        }

        if (block.querySelectorAll('.block-rates__card').length > 0) {
            App.ZagScrollAnimate.initialize(`#${CSS.escape(block.id)}`, {
                targets: [
                    { selector: '.block-rates__card', type: 'animate__fadeInUp', stagger: 150 }
                ]
            });
        }
    };

    const carousel = (el) => {
        const splideOptions = {
            mediaQuery: 'min',
            perPage: 1,
            gap: '1rem',
            pagination: false,
            arrows: true,
            breakpoints: {
                992: {
                    destroy: true,
                },
            },
        };

        App.Helpers.splideFallback(el, splideOptions, function (splide) {
            splide.on('mounted', function () {
                const prevBtn = el.querySelector('.splide__arrow--prev');
                const nextBtn = el.querySelector('.splide__arrow--next');
                if (prevBtn) {
                    prevBtn.classList.add('btn', 'btn-white');
                    prevBtn.innerHTML = '<span class="fa-regular fa-arrow-left" aria-hidden="true"></span>';
                }
                if (nextBtn) {
                    nextBtn.classList.add('btn', 'btn-white');
                    nextBtn.innerHTML = '<span class="fa-regular fa-arrow-right" aria-hidden="true"></span>';
                }
            });
        });
    };

    return { initialize };

})();
